import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { Router } from "@angular/router";
import { DataElement } from "src/app/shared/models/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Store } from "@ngrx/store";
import {
  SELECT_SUPPLY_TYPE,
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
} from "src/app/shared/ngrx/ngrx-actions";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-delivery-status",
  templateUrl: "./dash-delivery-status.component.html",
  styleUrls: ["./dash-delivery-status.component.scss"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashDeliveryStatusComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(
    private readonly store: Store,
    private router: Router,
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {}

  goToDeliveryOrder() {
    this.store.dispatch(
      SELECT_SUPPLY_TYPE({
        type: new DataElement("DELIVERY"),
      })
    );

    this._dispatchSuppliesNavigation();
    this.router.navigate([this.routeEnum.URL_SUPPLIES]);
  }

  _dispatchSuppliesNavigation() {
    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_SUPPLIES },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "supplies" },
      })
    );
  }

  getOpenOrderDateLbl(date: Date): string {
    let lbl = this.translateService.instant(
      "translate.dashboard.openOrderDate"
    ) as string;
    lbl = lbl.replace("%DATE%", this.datePipe.transform(date, "dd/MM/yyyy"));
    lbl = lbl.replace("%TIME%", this.datePipe.transform(date, "HH:mm"));
    return lbl;
  }
}
